import { useSelector } from 'react-redux';

const useStripeEnv = () => {
  const { userDetails } = useSelector((s) => s.user);
  const stripeEnv =
    userDetails?.stripeAccVersion === 'v2'
      ? import.meta.env.REACT_APP_NEW_STRIPE_KEY
      : import.meta.env.REACT_APP_OLD_STRIPE_KEY;
  return stripeEnv;
};

export { useStripeEnv };
